'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gregorianCalendarFormatLibLocaleEn_US = require('gregorian-calendar-format/lib/locale/en_US');

var _gregorianCalendarFormatLibLocaleEn_US2 = _interopRequireDefault(_gregorianCalendarFormatLibLocaleEn_US);

var _gregorianCalendarLibLocaleEn_US = require('gregorian-calendar/lib/locale/en_US');

var _gregorianCalendarLibLocaleEn_US2 = _interopRequireDefault(_gregorianCalendarLibLocaleEn_US);

exports['default'] = {
  clear: 'Clear',
  format: _gregorianCalendarFormatLibLocaleEn_US2['default'],
  calendar: _gregorianCalendarLibLocaleEn_US2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-time-picker/lib/locale/en_US.js
 ** module id = 829
 ** module chunks = 0
 **/